import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ProjectWorkLocationQuestion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedWorkLocation: this.props.workLocation,
      officeLocation: this.props.officeLocation || '',
      specificOfficeDays: this.props.specificOfficeDays,
      daysInOffice: this.props.daysInOffice || '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.setUncertainDaysInOffice = this.setUncertainDaysInOffice.bind(this);
    this.updateDaysInOffice = this.updateDaysInOffice.bind(this);
    this.setSpecificOfficeDays = this.setSpecificOfficeDays.bind(this);
  }

  componentDidMount() {
    const input = document.getElementById('project_office_location');
    const geocoder = new window.google.maps.places.Autocomplete(input);
    geocoder.setTypes(['(cities)']);

    window.google.maps.event.addDomListener(input, 'keydown', (e) => {
      if (e.keyCode === 13) {
        e.preventDefault();
      }
    });

    geocoder.addListener('place_changed', () => {
      this.setState({ officeLocation: input.value });
    });
  }

  setUncertainDaysInOffice() {
    this.setState({ daysInOffice: '', specificOfficeDays: false });
  }

  setSpecificOfficeDays() {
    this.setState({ specificOfficeDays: true });
  }

  handleChange(event) {
    const officeLocation = event.target.value;
    this.setState({ officeLocation });
  }

  // Because of the way we are wrapping radio buttons with the labels styled as bootstrap buttons
  // the normal react onChange event on the inputs never fire. To work around it,
  // we have to handle an onClick on the label itself.
  changeWorkLocationFromLabel(selectedWorkLocation) {
    this.setState({ selectedWorkLocation });
  }

  updateDaysInOffice(event) {
    this.setState({ daysInOffice: event.target.value });
  }

  renderWorkLocationQuestion() {
    const { workLocationCollection } = this.props;
    const { selectedWorkLocation } = this.state;
    return (
      <div>
        <label
          className="required"
          htmlFor="project_work_location"
        >
          Where will the consultant be based out of?
        </label>
        <div className="form-group" id="project_work_location">
          <div className="clf-check-radio-buttons" data-toggle="buttons">
            {Object.entries(workLocationCollection).map((option) => (
              <label
                className={`btn btn-default ${selectedWorkLocation === option[0] ? 'active' : ''}`}
                htmlFor={`project_work_location_${option[0]}`}
                key={`work_location_${option[0]}`}
                onClick={() => this.changeWorkLocationFromLabel(option[0])}
              >
                <input
                  type="radio"
                  value={option[0]}
                  defaultChecked={selectedWorkLocation === option[0]}
                  name="project[work_location]"
                  id={`project_work_location_${option[0]}`}
                />
                {option[1]}
              </label>
            ))}
          </div>
        </div>
      </div>
    );
  }

  renderOfficeDaysQuestion() {
    const { selectedWorkLocation } = this.state;
    if (!['office', 'both'].includes(selectedWorkLocation)) {
      // Only show this question if "Office" or "Office and Remote" are selected
      return null;
    }

    const { uncertainOfficeDays } = this.props;

    return (
      <div>
        <label htmlFor="project_office_days">
          What is the minimum number of days per week
          that the consultant will be working in the office?
        </label>

        <div className="form-group uncertainty-or-specified-amount" id="project_office_days">
          <div className="form-inline">
            <input
              type="radio"
              value=""
              name="project[office_days]"
              onChange={this.setSpecificOfficeDays}
              checked={this.state.specificOfficeDays}
            />

            <div className="input-group fifty-percent-width pl-5">
              <input
                type="number"
                value={this.state.daysInOffice}
                className="form-control"
                onChange={this.updateDaysInOffice}
                name="project[days_in_office]"
                id="project_days_in_office"
                onFocus={this.setSpecificOfficeDays}
              />
              <span className="input-group-addon"> days / week</span>
            </div>
          </div>

          <div className="form-inline">
            <input
              type="radio"
              value={uncertainOfficeDays}
              name="project[office_days]"
              id="project_office_days_na"
              onChange={this.setUncertainDaysInOffice}
              checked={!this.state.specificOfficeDays}
            />
            <label htmlFor="project_office_days_na" className="default-radio-label ps-3">
              I&apos;m not sure
            </label>
          </div>
        </div>
      </div>
    );
  }

  renderOfficeLocationQuestion() {
    const { selectedWorkLocation } = this.state;
    // Only show this question if "Office" or "Office and Remote" are selected
    const required = ['office', 'both'].includes(selectedWorkLocation) ? 'required' : '';
    const { officeLocation } = this.state;

    return (
      <div className="form-group office-location">
        <label
          htmlFor="project_office_location"
          className={required}
        >
          Where is your office located?
        </label>
        <input
          className="form-control form-control--light"
          placeholder="e.g. Boston"
          type="text"
          value={officeLocation}
          name="project[office_location]"
          id="project_office_location"
          onChange={this.handleChange}
        />
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.renderWorkLocationQuestion()}
        {this.renderOfficeDaysQuestion()}
        {this.renderOfficeLocationQuestion()}
      </div>
    );
  }
}

ProjectWorkLocationQuestion.propTypes = {
  workLocation: PropTypes.string,
  workLocationCollection: PropTypes.shape({}).isRequired,
  uncertainOfficeDays: PropTypes.string.isRequired,
  daysInOffice: PropTypes.number,
  specificOfficeDays: PropTypes.bool.isRequired,
  officeLocation: PropTypes.string,
};

ProjectWorkLocationQuestion.defaultProps = {
  workLocation: null,
  officeLocation: '',
  daysInOffice: '',
};

export default ProjectWorkLocationQuestion;
